import { Form, Row, Col } from "react-bootstrap";
import { FaFilter, FaSearch } from "react-icons/fa";

const ClientFilters = ({ searchQuery, setSearchQuery, employeeFilter, setEmployeeFilter, employees, stepFilter,
  setStepFilter, paymentFilter, setPaymentFilter, serviceFilter, setServiceFilter
}) => {
  return (
    <div className="filters-section mb-4 p-3 bg-light rounded">
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label><FaSearch /> Search Clients</Form.Label>
            <Form.Control
              type="text"
              placeholder="Search by name or email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label><FaFilter /> Filter by Employee</Form.Label>
            <Form.Select
              value={employeeFilter}
              onChange={(e) => setEmployeeFilter(e.target.value)}
            >
              <option value="all">All Employees</option>
              {employees.map((employee) => (
                <option key={employee._id} value={employee._id}>
                  {employee.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label><FaFilter /> Filter by Step</Form.Label>
            <Form.Select
              value={stepFilter}
              onChange={(e) => setStepFilter(e.target.value)}
            >
              <option value="all">All Steps</option>
              <option value="2">Step 2 Completed</option>
              {/* <option value="3">Step 3 Completed</option> */}
              <option value="3">Step 3 Completed</option>
              <option value="4">Step 4 Completed</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label><FaFilter /> Payment Status</Form.Label>
            <Form.Select
              value={paymentFilter}
              onChange={(e) => setPaymentFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="paid">Paid</option>
              <option value="unpaid">Unpaid</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label> Services </Form.Label>
            <Form.Select
              value={serviceFilter}
              onChange={(e) => setServiceFilter(e.target.value)}
            >
              <option value="all">All Services</option>
              <option value="usa">USA Company</option>
              <option value="tax">Tax Filing</option>
              <option value="bookkeeping">Bookkeeping</option>
              <option value="cfo">CFO Advisory</option>
              <option value="registeredAgent">Registered Agent</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default ClientFilters;